export const banks = [
  {
    value: 0,
    label: 'نام بانک',
  },
  {
    value: 'markazi',
    label: "بانک مرکزی",
  },
  {
    value: 'sanatmadan',
    label: 'بانک صنعت و معدن',
  },
  {
    value: 'mellat',
    label: 'بانک ملت',
  },
  {
    value: 'refah',
    label: 'بانک رفاه',
  },
  {
    value: 'maskan',
    label: 'بانک مسکن',
  },
  {
    value: 'sepah',
    label: 'بانک سپه',
  },
  {
    value: 'keshavarsi',
    label: 'بانک کشاورزی',
  },
  {
    value: 'meli',
    label: 'بانک ملی ایران',
  },
  {
    value: 'tejarat',
    label: 'بانک تجارت',
  },
  {
    value: 'saderat',
    label: 'بانک صادرات',
  },
  {
    value: 'tooseesaderat',
    label: 'بانک توسعه صادرات',
  },
  {
    value: 'postbank',
    label: 'بانک توسعه تعاون',
  },
  {
    value: 'etebaritosee',
    label: 'موسسه اعتباری توسعه',
  },
  {
    value: 'karafarin',
    label: 'بانک کارآفرین',
  },
  {
    value: 'parsian',
    label: 'بانک پارسیان',
  },
  {
    value: 'eghtesad',
    label: 'بانک اقتصاد نوین',
  },
  {
    value: 'saman',
    label: 'بانک سامان',
  },
  {
    value: 'pasargad',
    label: 'بانک پاسارگاد',
  },
  {
    value: 'sarmaye',
    label: 'بانک سرمایه',
  },
  {
    value: 'sina',
    label: 'بانک سینا',
  },
  {
    value: 'gharzolhasaneh',
    label: 'بانک قرض الحسنه مهر',
  },
  {
    value: 'tat',
    label: 'بانک تات',
  },
  {
    value: 'ansar',
    label: 'بانک انصار',
  },
  {
    value: 'gardeshgari',
    label: 'بانک گردشگری',
  },
  {
    value: 'hekmat',
    label: 'بانک حکمت ایرانیان',
  },
  {
    value: 'day',
    label: 'بانک دی',
  },
  {
    value: 'iranzamin',
    label: 'بانک ایران زمین',
  },
];
